import { render, staticRenderFns } from "./Charge.vue?vue&type=template&id=7070f031&"
import script from "./Charge.vue?vue&type=script&lang=js&"
export * from "./Charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports